 const generateProductName = ({
  make,
  category,
  subCategory,
  type,
  model,
}: {
  make: string;
  category: string;
  subCategory: string;
  type: string[];
  model: string;
}) => {
  return [
    make,
    category,
    subCategory,
    ...(type || []),
    model,
  ]
    .filter(Boolean) // removes undefined/null only
    .join(" ");
};

export default generateProductName;